import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { RecoilRoot } from "recoil";

//관리자
import AdminFlatForm from "./admin/components/includes/AdminFlatForm";
import MainAdmin from "./admin/pages/MainAdmin";
import LoginAdmin from "./admin/pages/members/LoginAdmin";

import BranchList from "./admin/pages/branchs/BranchList";
import BranchDetail from "./admin/pages/branchs/BranchDetail";
import RoyaltyInformation from "./admin/pages/branchs/RoyaltyInformation";

import CourseList from "./admin/pages/courses/CourseList";
import CourseDetail from "./admin/pages/courses/CourseDetail";

import AnalysisList from "./admin/pages/analysis/AnalysisList";
import AnalysisDetail from "./admin/pages/analysis/AnalysisDetail";

import CertificationList from "./admin/pages/certifications/CertificationList";

import PaymentList from "./admin/pages/payments/PaymentList";
import SalesList from "./admin/pages/sales/SalesList";
import SalesDetail from "./admin/pages/sales/SalesDetail";
import SettlementList from "./admin/pages/settlements/SettlementList";
import SettlementDetail from "./admin/pages/settlements/SettlementDetail";
import TextBookList from "./admin/pages/settlements/TextBookList";
import TextBookDetails from "./admin/pages/settlements/TextBookDetail";

import MemberList from "./admin/pages/members/MemberList";
import MemberDetail from "./admin/pages/members/MemberDetail";

import AdminInformation from "./admin/pages/environments/AdminInformation";
import SubAdminInformation from "./admin/pages/environments/SubAdminInformation";
import AdminTerm from "./admin/pages/environments/AdminTerm";

import NoticeList from "./admin/pages/boards/NoticeList";
import NoticeDetailAdm from "./admin/pages/boards/NoticeDetail";
import FaqList from "./admin/pages/boards/FaqList";
import FaqDetail from "./admin/pages/boards/FaqDetail";

import Business from "./admin/pages/variables/Business";
import ChildrenLevel from "./admin/pages/variables/ChildrenLevel";
import SettlementSerious from "./admin/pages/variables/SettlementSerious";
import FaqType from "./admin/pages/variables/FaqType";
import TextBooks from "./admin/pages/variables/TextBooks";
import Mamamonte from "./admin/pages/variables/Mamamonte";
import MamamonteDetail from "./admin/pages/variables/MamamonteDetail";
import Fly from "./admin/pages/variables/Fly";

//센터
import BranchFlatForm from "./branchs/components/includes/BranchFlatForm";
import LoginBranch from "./branchs/members/LoginBranch";
import MainBranch from "./branchs//MainBranch";

import FindIDBranch from "./branchs/members/FindIDBranch";
import FoundIDOKBranch from "./branchs/members/FoundIDOKBranch";
import FindPWDBranch from "./branchs/members/FindPWDBranch";
import EditPWDBranch from "./branchs/members/EditPWDBranch";
import JoinUsBranch from "./branchs/members/JoinUsBranch";
import JoinUsOKBranch from "./branchs/members/JoinUsOKBranch";

import Setting from "./branchs/settings/Setting";
import SetClassroom from "./branchs/settings/SetClassroom";
import SemesterSet from "./branchs/settings/SemesterSet";
import SemesterDetail from "./branchs/settings/SemesterDetail";
import SemesterCopy from "./branchs/settings/SemesterCopy";

import ClassSet from "./branchs/settings/ClassSet";
import ClassDetail from "./branchs/settings/ClassDetail";

import ClassInformation from "./branchs/course/ClassInformation";
import ChildrenInformation from "./branchs/course/ChildrenInformation";
import StudentChildrenMove from "./branchs/course/StudentChildrenMove";

import ToggleClassStudy from "./branchs/course/ToggleClassStudy";
import ToggleStudySet from "./branchs/course/ToggleStudySet";

import CertificatesSet from "./branchs/course/CertificatesSet";
import CertificateOrder from "./branchs/course/CertificateOrder";
import CertificateIssue from "./branchs/course/CertificateIssue";

import StudyChildrenSet from "./branchs/course/StudyChildrenSet";
import StudyChildrenAdd from "./branchs/course/StudyChildrenAdd";

import ReinForceSet from "./branchs/course/ReinForceSet";
import ReinForceDetail from "./branchs/course/ReinForceDetail";
import ParticipationSet from "./branchs/course/ParticipationSet";


import ParentSet from "./branchs/members/ParentSet";
import ParentDetail from "./branchs/members/ParentDetail";
import ChildrenSet from "./branchs/members/ChildrenSet";

import PaymentSet from "./branchs/payments/PaymentSet";
import PaymentHistory from "./branchs/payments/PaymentHistory";
import PaymentCancel from "./branchs/payments/PaymentCancel";

import InvoiceSet from "./branchs/payments/InvoiceSet";
import InvoiceSending from "./branchs/payments/InvoiceSending";

import TextBookOrder from "./branchs/payments/TextBookOrder";
import TextBookDetail from "./branchs/payments/TextBookDetail";
import TextBookShow from "./branchs/payments/TextBookShow";

import SettlementSet from "./branchs/payments/SettlementSet";
import SettlementDetails from "./branchs/payments/SettlementDetail";

import SalesReport from "./branchs/payments/SalesReport";

import AnalysisSet from "./branchs/analysis/AnalysisSet";
import MamaMonteDetail from "./branchs/analysis/MamaMonteDetail";
import MamaMonteView from "./branchs/analysis/MamaMonteView";

import FlyDetail from "./branchs/analysis/FlyDetail";
import FlyView from "./branchs/analysis/FlyView";

import Operating from "./branchs/mypage/Operating";
import Condition from "./branchs/mypage/Condition";
import NoticeSet from "./branchs/mypage/NoticeSet";
import NoticeDetail from "./branchs/mypage/NoticeDetail";
import BranchInfo from "./branchs/mypage/BranchInfo";
import InquirySet from "./branchs/mypage/InquirySet";
import InquiryDetail from "./branchs/mypage/InquiryDetail";

//사용자
import ParentFlatForm from "./parents/components/includes/ParentFlatForm";
import Attendance from "./parents/Attendance";
import MainParent from "./parents/MainParent";
import LoginParent from "./parents/member/LoginParent";
import FindID from "./parents/member/FindID";
import FoundIDOK from "./parents/member/FoundIDOK";
import FindPWD from "./parents/member/FindPWD";
import EditPWD from "./parents/member/EditPWD";

import ClassList from "./parents/course/ClassList";
import ClassStudy from "./parents/course/ClassStudy";

import Certificates from "./parents/course/Certificates";
import CertificateView from "./parents/course/CertificateView";


import Analysis from "./parents/analysis/Analysis";
import AnalysisMonte from "./parents/analysis/AnalysisMonte";
import AnalysisFly from "./parents/analysis/AnalysisFly";

import ReinForce from "./parents/reinforce/ReinForce";
import ReinForiceStudy from "./parents/reinforce/ReinForiceStudy";

import MyPage from "./parents/mypage/MyPage";
import MyInfo from "./parents/mypage/MyInfo";

import Notice from "./parents/mypage/Notice";
import NoticeView from "./parents/mypage/NoticeView";
import Faq from "./parents/mypage/Faq";
import Question from "./parents/mypage/Question";
import QuestionView from "./parents/mypage/QuestionView";
import QuestionAdd from "./parents/mypage/QuestionAdd";
import Terms from "./parents/mypage/Terms";

function App() {

  return (
    <RecoilRoot>
      <BrowserRouter>
        <Routes>
          {/* 관리페이지들 */}
          <Route element={<AdminFlatForm/>}>
            <Route path="/Admin" element={<MainAdmin/>} />
            <Route path="/MainAdmin" element={<MainAdmin/>} />
            
            <Route path="/Admin/BranchList" element={<BranchList/> } />
            <Route path="/Admin/BranchDetail/:editMode/:bh_idx" element={<BranchDetail/> } />
            <Route path="/Admin/RoyaltyInformation" element={<RoyaltyInformation/> } />

            <Route path="/Admin/CourseList" element={<CourseList/> } />
            <Route path="/Admin/CourseDetail/:cl_idx" element={<CourseDetail/> } />

            <Route path="/Admin/AnalysisList" element={<AnalysisList/> } />
            <Route path="/Admin/AnalysisDetail/:cl_idx/:ch_idx" element={<AnalysisDetail/> } />

            <Route path="/Admin/CertificationList" element={<CertificationList/> } />
            <Route path="/Admin/PaymentList" element={<PaymentList/> } />
            <Route path="/Admin/SalesList" element={<SalesList/> } />
            <Route path="/Admin/SalesDetail/:bh_idx/:months" element={<SalesDetail/> } />
            <Route path="/Admin/SettlementList" element={<SettlementList/> } />
            <Route path="/Admin/SettlementDetail/:st_idx/:terms" element={<SettlementDetail/> } />
            <Route path="/Admin/TextBookList" element={<TextBookList/> } />
            <Route path="/Admin/TextBookDetail/:bh_idx/:terms" element={<TextBookDetails/> } />
            
            <Route path="/Admin/MemberList" element={<MemberList/> } />
            <Route path="/Admin/MemberDetail/:mem_idx" element={<MemberDetail/> } />
            
            <Route path="/Admin/NoticeList" element={<NoticeList/> } />
            <Route path="/Admin/NoticeDetail/:board_idx" element={<NoticeDetailAdm/> } />
            <Route path="/Admin/FaqList" element={<FaqList/> } />
            <Route path="/Admin/FaqDetail/:board_idx" element={<FaqDetail/> } />
            <Route path="/Admin/AdminTerm/:termMode" element={<AdminTerm/> } />
            
            <Route path="/Admin/AdminInformation" element={<AdminInformation/> } />
            <Route path="/Admin/SubAdminInformation" element={<SubAdminInformation/> } />

            <Route path="/Admin/Business" element={<Business/> } />
            <Route path="/Admin/ChildrenLevel" element={<ChildrenLevel/> } />
            <Route path="/Admin/SettlementSerious" element={<SettlementSerious/> } />
            <Route path="/Admin/FaqType" element={<FaqType/> } />
            <Route path="/Admin/TextBooks" element={<TextBooks/> } />
            <Route path="/Admin/Mamamonte" element={<Mamamonte/> } />
            <Route path="/Admin/MamamonteDetail/:vt_idx" element={<MamamonteDetail/> } />
            <Route path="/Admin/Fly" element={<Fly/> } />
            
          </Route>
          <Route path="/LoginAdmin" element={<LoginAdmin/>} /> 

          {/* 센터 */}
          <Route element={<BranchFlatForm/>}>
            <Route path="/MainBranch" element={<MainBranch/>} />

            <Route path="/Branch/FindID" element={<FindIDBranch/>} />
            <Route path="/Branch/FoundIDOK" element={<FoundIDOKBranch/>} />
            <Route path="/Branch/FindPWD" element={<FindPWDBranch/>} />
            <Route path="/Branch/EditPWD" element={<EditPWDBranch/>} />
            <Route path="/Branch/JoinUs" element={<JoinUsBranch/>} />
            <Route path="/Branch/JoinUsOK" element={<JoinUsOKBranch/>} />

            <Route path="/Branch/Setting" element={<Setting/>} />
            <Route path="/Branch/SetClassroom" element={<SetClassroom/>} />

            <Route path="/Branch/SemesterSet" element={<SemesterSet/>} />
            <Route path="/Branch/SemesterDetail/:sm_idx" element={<SemesterDetail/>} />
            <Route path="/Branch/SemesterCopy/:sm_idx" element={<SemesterCopy/>} />

            <Route path="/Branch/ClassSet" element={<ClassSet/>} />
            <Route path="/Branch/ClassDetail/:cl_idx" element={<ClassDetail/>} />

            <Route path="/Branch/ClassInformation/:cl_idx" element={<ClassInformation/>} />
            <Route path="/Branch/ChildrenInformation/:ch_idx/:cl_idx" element={<ChildrenInformation/>} />
            <Route path="/Branch/StudentChildrenMove/:cl_idx" element={<StudentChildrenMove/>} />
            
            <Route path="/Branch/ToggleClassStudy/:ch_idx/:cl_idx" element={<ToggleClassStudy/>} />
            <Route path="/Branch/ToggleStudySet" element={<ToggleStudySet/>} />
            
            <Route path="/Branch/CertificatesSet" element={<CertificatesSet/>} />
            <Route path="/Branch/CertificateOrder/:ch_idx" element={<CertificateOrder/>} />
            <Route path="/Branch/CertificateIssue/:ce_idx" element={<CertificateIssue/>} />
            
            <Route path="/Branch/StudyChildrenSet/:cl_idx" element={<StudyChildrenSet/>} />
            <Route path="/Branch/StudyChildrenAdd/:cs_idx/:stType" element={<StudyChildrenAdd/>} />

            <Route path="/Branch/ReinForceSet" element={<ReinForceSet/>} />
            <Route path="/Branch/ReinForceDetail/:cl_idx" element={<ReinForceDetail/>} />
            <Route path="/Branch/ParticipationSet" element={<ParticipationSet/>} />
            
            <Route path="/Branch/ParentSet" element={<ParentSet/>} />
            <Route path="/Branch/ParentDetail/:mem_idx" element={<ParentDetail/>} />
            <Route path="/Branch/ChildrenSet" element={<ChildrenSet/>} />

            <Route path="/Branch/PaymentSet" element={<PaymentSet/>} />
            <Route path="/Branch/PaymentHistory/:ch_idx/:ph_idx" element={<PaymentHistory/>} />
            <Route path="/Branch/PaymentCancel/:ph_idx" element={<PaymentCancel/>} />
            
            <Route path="/Branch/InvoiceSet" element={<InvoiceSet/>} />
            <Route path="/Branch/InvoiceSending/:iv_idx" element={<InvoiceSending/>} />
            
            <Route path="/Branch/TextBookOrder" element={<TextBookOrder/>} />
            <Route path="/Branch/TextBookDetail/:tb_idx" element={<TextBookDetail/>} />
            <Route path="/Branch/TextBookShow/:st_idx/:tb_month" element={<TextBookShow/>} />
            
            <Route path="/Branch/SettlementSet" element={<SettlementSet/>} />
            <Route path="/Branch/SettlementDetail/:st_idx" element={<SettlementDetails/>} />

            <Route path="/Branch/SalesReport" element={<SalesReport/>} />

            <Route path="/Branch/AnalysisSet" element={<AnalysisSet/>} />
            <Route path="/Branch/MamaMonteDetail/:clc_idx" element={<MamaMonteDetail/>} />
            <Route path="/Branch/MamaMonteView/:clc_idx" element={<MamaMonteView/>} />
            <Route path="/Branch/FlyDetail/:clc_idx" element={<FlyDetail/>} />
            <Route path="/Branch/FlyView/:clc_idx" element={<FlyView/>} />
            
            <Route path="/Branch/Operating" element={<Operating/>} />
            <Route path="/Branch/Condition/:terms" element={<Condition/>} />
            <Route path="/Branch/NoticeSet" element={<NoticeSet/>} />
            <Route path="/Branch/NoticeDetail/:board_idx" element={<NoticeDetail/>} />
            <Route path="/Branch/BranchInfo" element={<BranchInfo/>} />
            <Route path="/Branch/InquirySet" element={<InquirySet/>} />
            <Route path="/Branch/InquiryDetail/:board_idx" element={<InquiryDetail/>} />
          </Route>
          <Route path="/Branch/Login" element={<LoginBranch/>} />
          <Route path="/LoginBranch" element={<LoginBranch/>} />

          {/* 학부모 */}
          <Route element={<ParentFlatForm/>}>
            <Route path="/" element={<MainParent/>} />
            <Route path="/Main" element={<MainParent/>} />
            <Route path="/MainParent" element={<MainParent/>} />
            <Route path="/Parents/FindID" element={<FindID/>} />
            <Route path="/Parents/FoundIDOK" element={<FoundIDOK/>} />
            <Route path="/Parents/FindPWD" element={<FindPWD/>} />
            <Route path="/Parents/EditPWD/:backMode" element={<EditPWD/>} />

            <Route path="/Parents/ClassList" element={<ClassList/>} />
            <Route path="/Parents/ClassStudy/:ch_idx/:cl_idx" element={<ClassStudy/>} />
            <Route path="/Parents/Certificates" element={<Certificates/>} />
            <Route path="/Parents/CertificateView/:ce_idx" element={<CertificateView/>} />
            
            <Route path="/Parents/Analysis" element={<Analysis/>} />
            <Route path="/Parents/AnalysisMonte/:clc_idx" element={<AnalysisMonte/>} />
            <Route path="/Parents/AnalysisFly/:clc_idx" element={<AnalysisFly/>} />
            
            <Route path="/Parents/ReinForce" element={<ReinForce/>} />
            <Route path="/Parents/ReinForiceStudy/:ch_idx/:cl_idx" element={<ReinForiceStudy/>} />
            
            <Route path="/Parents/MyPage" element={<MyPage/>} />
            <Route path="/Parents/MyInfo" element={<MyInfo/>} />
            <Route path="/Parents/Notice" element={<Notice/>} />
            <Route path="/Parents/NoticeView/:board_idx" element={<NoticeView/>} />
            <Route path="/Parents/Faq" element={<Faq/>} />
            <Route path="/Parents/Question" element={<Question/>} />
            <Route path="/Parents/QuestionView/:board_idx" element={<QuestionView/>} />
            <Route path="/Parents/QuestionAdd" element={<QuestionAdd/>} />
            <Route path="/Parents/Terms/:items" element={<Terms/>} />
            
          </Route>
          <Route path="/Parents/Login" element={<LoginParent/>} />
          <Route path="/LoginParents" element={<LoginParent/>} />
          <Route path="/Attendance" element={<Attendance/>} />
        </Routes>  
      </BrowserRouter> 
    </RecoilRoot>
  );
}

export default App;
